/**
 * Evaluates a feature of type boolean and returns its boolean value.
 *
 * This function checks if the provided feature has a value and interprets
 * the first value's key as a boolean, where the string '1' is considered `true`
 * and any other value (including absence) is considered `false`.
 *
 * @param feat - The feature object to evaluate, which may be undefined.
 * @returns `true` if the feature's first value key is '1', otherwise `false`.
 *
 * @example
 * ```ts
 * const feature = { values: [{ key: '1' }] };
 * const result = evalBoolFeature(feature);
 * // result === true
 * ```
 */
function evalBoolFeature(feat) {
    if (feat?.values?.[0]) {
        return feat.values[0].key === '1';
    }
    return false;
}

export { evalBoolFeature };
//# sourceMappingURL=evalBoolFeature.js.map
